import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators, UntypedFormControl } from '@angular/forms';
import { Router } from '@angular/router';
import { ZpDataService } from 'src/app/services/zp-data.service';
import { UserInfoService } from 'src/app/services/user-info.service';
import { Subscription } from 'rxjs';
import { SideNavBarVisibilityService } from 'src/app/services/side-nav-bar-visibility.service';
import { ThemeService } from 'src/app/theme/theme-service.service';

@Component({
    selector: 'app-payment-monthly-subscription',
    templateUrl: './payment-monthly-subscription.component.html',
    styleUrls: ['./payment-monthly-subscription.component.scss'],
    standalone: false
})
export class PaymentMonthlySubscriptionComponent implements OnInit {
  public submitted = false;
  public id;
  public Subscription: Subscription;
  public myUser;
  public f;

  public paymentChosenForm: UntypedFormGroup = new UntypedFormGroup({
    email: new UntypedFormControl(''),
    shortCode: new UntypedFormControl(''),
    accountNumber: new UntypedFormControl(''),
    address: new UntypedFormControl(''),
    acceptPolicy: new UntypedFormControl(''),
  })


  constructor(
    private fb: UntypedFormBuilder,
    private router: Router,
    private zenplansDataService: ZpDataService,
    private userInfoService: UserInfoService,
    public sideNavBarVisibilityService: SideNavBarVisibilityService,
    public themeService: ThemeService
  ) { }

  async ngOnInit() {
    this.Subscription = this.userInfoService.getMessage().subscribe(user => {
      this.myUser = JSON.parse(user);
    });

    await this.getMyUser();

    // Form Payment Type
    this.paymentChosenForm.addControl("email", new UntypedFormControl(this.myUser.email))
    this.paymentChosenForm.addControl("shortCode", new UntypedFormControl(this.myUser.shortCode))
    this.paymentChosenForm.addControl("accountNumber", new UntypedFormControl(this.myUser.accountNumber))
    this.paymentChosenForm.addControl("address", new UntypedFormControl(this.myUser.address))
    this.paymentChosenForm.addControl("acceptPolicy", new UntypedFormControl(this.myUser.acceptPolicy))
  }

  async getMyUser() {
    if (!this.myUser) {
      await this.zenplansDataService.getUser();
    }
  }

  async onSubmit() {
    this.submitted = true;

    if (this.paymentChosenForm.invalid) {
      return;
    }

    // Form payment ChosenForm
    this.myUser["email"] = this.paymentChosenForm.value["email"];
    this.myUser["shortCode"] = this.paymentChosenForm.value["shortCode"];
    this.myUser["accountNumber"] = this.paymentChosenForm.value["accountNumber"];
    this.myUser["address"] = this.paymentChosenForm.value["address"];
    this.myUser["acceptPolicy"] = this.paymentChosenForm.value["acceptPolicy"];

    await this.zenplansDataService.updateUser(this.myUser);
    this.router.navigateByUrl('/home' + this.myUser.Id);
  }


}
